import ComingSoon from "components/ComingSoon/ComingSoon";
import React from "react";

const PrivatePolicy = () => {
  return <ComingSoon />;
};

export default PrivatePolicy;
